export function validate_object_entries(entry_validator) {
    return (object, extra) => {
        let empty = true;
        const result = {};
        Object.entries(object).forEach((entry) => {
            const item_result = entry_validator(entry, extra);
            if (item_result != null) {
                result[entry[0]] = item_result;
                empty = false;
            }
        });
        if (empty) {
            return null;
        }
        return result;
    };
}
export function all(...args) {
    return (value, extra) => {
        for (const validator of args) {
            const error = validator(value, extra);
            if (error != null) {
                return error;
            }
        }
        return null;
    };
}
export function any(...args) {
    return (value, extra) => {
        let error = null;
        for (const validator of args) {
            error = validator(value, extra);
            if (error == null)
                return null;
        }
        return error;
    };
}
function merge(o1, o2) {
    if (o2 == null)
        return o1;
    if (o1 == null)
        return o2;
    if (typeof o1 !== 'object' && typeof o2 !== 'object')
        return `${o1}. ${o2}`;
    if (typeof o1 !== 'object' && typeof o2 === 'object')
        return o2;
    if (typeof o2 !== 'object' && typeof o1 === 'object')
        return o1;
    const result = { ...o1 };
    for (const k of Object.keys(o2)) {
        // @ts-ignore
        result[k] = merge(o1[k], o2[k]);
    }
    return result;
}
export function all_merge(...validators) {
    return (value, extra) => validators.map((validator) => validator(value, extra)).reduce(merge);
}
export function check_null_values(obj) {
    const result = {};
    let flag = false;
    for (const [k, v] of Object.entries(obj)) {
        if (v != null) {
            flag = true;
            result[k] = v;
        }
    }
    return flag ? result : null;
}
export function validate_array(item_validator) {
    return (array, extra) => {
        const result = array.map((item) => item_validator(item, extra));
        return result.filter((item) => item != null).length ? result : null;
    };
}
export function validate_array_with_index(item_validator) {
    return (array, extra) => {
        const result = array.map((item, index) => item_validator(item, extra, index));
        return result.filter((item) => item != null).length ? result : null;
    };
}
export function validate_list(item_validator) {
    return (list, extra) => {
        const result = list.map((item) => item_validator(item, extra));
        if (result.some((item) => item != null))
            return result;
        return null;
    };
}
export function validate_map(kv_validator) {
    return (map, extra) => {
        const result = map
            .map((value, key) => kv_validator(key, value, extra))
            .filter((item_validation) => item_validation != null);
        if (result.size > 0)
            return result;
        return null;
    };
}
export function validate_by_specification(specification) {
    return (item, extra) => {
        let all_good = true;
        const result = {};
        for (const key of Object.keys(specification)) {
            const item_validator = specification[key];
            if (item_validator == null)
                continue;
            const item_result = item_validator(item[key], extra);
            if (item_result != null) {
                result[key] = item_result;
                all_good = false;
            }
        }
        return all_good ? null : result;
    };
}
